import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Icon } from "@iconify/react/dist/iconify.js";
import { getEstadisticasCompletasThunk } from "../../../store/reducers/dashboard/resultadosEvaluacion/resultadosEvaluacion.thunks";

const EstadisticasEvaluacion = () => {
  const dispatch = useDispatch();
  const { estadisticas, estadisticasLoading } = useSelector(
    (state) => state.resultadosEvaluacion
  );
  const { escuela, plantel } = useSelector((state) => state.dashboardFilters);

  useEffect(() => {
    dispatch(getEstadisticasCompletasThunk());
  }, [dispatch, escuela, plantel]);

  const statsConfig = [
    {
      key: "total",
      label: "Total Evaluaciones",
      icon: "solar:users-group-rounded-bold",
      iconColor: "text-primary-600",
      bgColor: "bg-primary-focus",
      value: estadisticas.total,
    },
    {
      key: "completada",
      label: "Completadas",
      icon: "solar:check-circle-bold",
      iconColor: "text-success-600",
      bgColor: "bg-success-focus",
      value: estadisticas.completada,
    },
    {
      key: "en_progreso",
      label: "En Progreso",
      icon: "solar:clock-circle-bold",
      iconColor: "text-warning-600",
      bgColor: "bg-warning-focus",
      value: estadisticas.en_progreso,
    },
    {
      key: "sin_sesion",
      label: "Sin Iniciar",
      icon: "solar:forbidden-circle-bold",
      iconColor: "text-neutral-600",
      bgColor: "bg-neutral-100",
      value: estadisticas.sin_sesion,
    },
  ];

  return (
    <div className="row gy-4 mb-24">
      {statsConfig.map((stat) => (
        <div key={stat.key} className="col-xxl-3 col-sm-6">
          <div className="card px-24 py-16 shadow-none radius-8 border h-100 bg-gradient-start-1">
            <div className="card-body p-0">
              <div className="d-flex flex-wrap align-items-center justify-content-between gap-1">
                <div>
                  <span className="mb-2 fw-medium text-secondary-light text-sm">
                    {stat.label}
                  </span>
                  <h6 className="fw-semibold mb-0">
                    {estadisticasLoading ? (
                      <span className="text-secondary-light">...</span>
                    ) : (
                      stat.value
                    )}
                  </h6>
                </div>
                <div
                  className={`w-64-px h-64-px radius-16 d-flex justify-content-center align-items-center ${stat.bgColor}`}
                >
                  <Icon
                    icon={stat.icon}
                    className={`text-xxl ${stat.iconColor}`}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default EstadisticasEvaluacion;
